const constants = {
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  EUER: 'euer',
  ACCOUNTING: 'accounting',
}

module.exports = constants
